import { extractResources } from '@/lti/api/helpers'
import Vue from 'vue'
import _cloneDeep from 'lodash/cloneDeep'

/**
 * Stores an entity to vuex
 * @param objects the objects to add (required to have an id attribute)
 * @param storage the vuex store
 * @param default props to set if they don't exist in object
 */
export function storeEntities ({ entities, storage, defaults, idKey }) {
  if (entities == null) {
    return
  }

  defaults = defaults || {}
  idKey = idKey || 'id'

  for (const entity of entities) {
    const existing = storage[entity[idKey]]
    if (existing != null) {
      // don't replace, update all properties
      // otherwise this entity is considered a totally new entity
      // note that defaults are not set here, they should not overwrite already set values
      for (const prop in entity) {
        existing[prop] = entity[prop]
      }
    } else {
      Vue.set(storage, entity[idKey], Object.assign({}, _cloneDeep(defaults), entity))
    }
  }
}

/**
 *
 * @param commit
 * @returns {function(*=): {meta: (*|{}), primaryResources: *}}
 */
export function storeAllEntities (commit) {
  return resources => {
    const extractedResources = extractResources(resources)
    commit('STORE_ENTITIES', extractedResources)

    return extractedResources
  }
}
